import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TokenInput from 'react-tokeninput';
import { CheckForIcons } from './check-icon';
import { CheckForError } from './check-error';
import { validateEmail } from '../../../utils/validate-email';

import _ from 'lodash';
import { injectIntl } from 'react-intl';

function parseInput (input) {
  // This regex replace out all delimeters (space, comma, semi-colon, hypen), removes < >'s
  // with commas, then splits on the commas.
  const result = input
    .replace(/([\><])/g, '')
    .replace(/(\s[\s;,]\s?)|(\s?[;,]\s)|(\s?[\s])|([;,])/g, ',')
    .split(',');

  return result;
}

class TokenField extends Component {
  constructor (props) {
    super(props);

    this.checkErrors = this.checkErrors.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.getValue = this.getValue.bind(this);
    this.onInput = this.onInput.bind(this);

    this.state = {
      selected: [],
      placeholder: this.props.intl.formatMessage({ id: 'boards.token_field.enter_emails', defaultMessage: 'Enter emails separated by commas' }),
      input: '',
      error: null
    };
  }

  onSelect (value) {
    const input = parseInput(value);

    // TokenInput requires an array of objects with `id` and `name`.
    const values = input.map(val => {
      return {
        id: val,
        name: val
      };
    });


    // Remove duplicates and add to existing items.
    const selected = _.uniqBy(this.state.selected.concat(values), 'id');

    this.onChange(selected);
  }

  onChange (vals) {
    const { changeCallback } = this.props;
    const emailsInputBox = document.querySelector('.ic-tokens');

    if (changeCallback) {
      // Populate as array of values.
      const transformed = this.transformSelected(vals);

      changeCallback(transformed);
    }

    emailsInputBox.scrollTop = emailsInputBox.scrollHeight;

    this.setState({
      selected: vals
    }, () => {
      // Add || Remove placeholder text.
      this.handlePlaceholder();

      // Check for errors.
      this.checkErrors();
    });
  }

  onRemove (value) {
    const selected = _.uniq(_.without(this.state.selected, value));

    this.onChange(selected);
  }

  onInput (input) {
    this.setState({
      input
    });
  }

  getValue () {
    const { selected } = this.state;
    const transformed = this.transformSelected(selected);

    return transformed;
  }

  checkErrors () {
    const { selected } = this.state;

    // Find enteries that are not emails and highlight them.
    selected.forEach(s => {
      if (!validateEmail(s.name)) {
        $(`.ic-token-label:contains("${s.name}")`).filter((i, el) => {
          return $(el).text() === s.name;
        }).parent().addClass('error');
      }
    });

    this.isValid();
  }

  isValid () {
    const { selected } = this.state;
    let isValid = false;

    if (selected.length) {
      const transformed = this.transformSelected(selected);
      isValid = transformed.every(s =>
        validateEmail(s)
      );
    }

    this.errorFn(isValid);
    return isValid;
  }

  errorFn (isValid) {
    this.setState({ error: !isValid });
    if (isValid) {
      $('.ic-tokens').removeClass('error');
    } else {
      $('.ic-tokens').addClass('error');
    }
  }

  transformSelected (selected) {
    // Populate as array of values.
    const result = selected.map(s => s.name);

    return result;
  }

  // Placeholder text is removed when one or more items exist.
  handlePlaceholder () {
    const { selected } = this.state;

    if (0 === selected.length) {
      return this.setState({
        placeholder: this.props.intl.formatMessage({ id: 'boards.token_field.placeholder_emails', defaultMessage: 'Enter emails separated by commas.' })
      });
    }

    return this.setState({
      placeholder: ''
    });
  }

  render () {
    const { selected, placeholder, error } = this.state;
    const { options } = this.props;

    return (
      <div className="token-input-field">
        <TokenInput
          ref="tokenInput"
          placeholder={ placeholder }
          menuContent={ options || [] }
          selected={ selected }
          onSelect={ this.onSelect }
          onChange={ this.onChange }
          onRemove={ this.onRemove }
          onInput={ this.onInput }
        />
        <CheckForIcons
          error={error}
        />
        <CheckForError
          error={error}
          message={ this.props.intl.formatMessage({ id: 'boards.token_field.valid_emails', defaultMessage: 'Please enter valid emails.' }) }
        />
      </div>
    );
  }
}

TokenField.propTypes = {
  options: PropTypes.array,
  changeCallback: PropTypes.func
};

exports.TokenField = injectIntl(TokenField, { withRef: true });
